import { format } from 'date-fns';
import { Warranty } from 'types/warranty';

/**
 * A garancia adatokat a dokumentumgeneráláshoz használható kulcs-érték párokká alakítja
 * 
 * @param warranty A garancia objektum
 * @returns A kulcs-érték párok objektuma, ami a dokumentumgeneráláshoz használható
 */
export const warrantyToKeyValuePairs = (warranty: Warranty): Record<string, string> => {
  // Lemásoljuk a sablont, hogy ne módosítsuk az eredetit
  const mappedData = { ...warrantyKeys } as Record<string, string>;

  if (!warranty) return mappedData;

  // Termék adatok
  mappedData['Termék gyártmánya, típusa'] = `${warranty.manufacturer || ''} ${warranty.model || ''}`.trim();
  mappedData['Gyártási szám'] = warranty.serialNumber || '';
  
  // Eladó és vásárló
  mappedData['Eladó neve'] = warranty.supplierName || '';
  mappedData['Vásárló neve'] = warranty.customerName || '';
  
  // Garancia időtartamok (hónapokban)
  mappedData['Alap garancia ideje'] = warranty.durationMonths ? `${warranty.durationMonths} hónap` : '';
  mappedData['Extra garancia ideje'] = ''; // Ezt manuálisan kell kitölteni a sablonban
  
  // Aktuális dátum
  mappedData['Dátum'] = format(new Date(), 'yyyy.MM.dd.');

  return mappedData;
};

/**
 * Garancia típus nevének lekérése magyar nyelven
 */
export const getWarrantyTypeName = (type: string): string => {
  const typeNames: Record<string, string> = {
    'manufacturer': 'Gyártói garancia',
    'seller': 'Forgalmazói garancia',
    'extended': 'Kiterjesztett garancia',
    'service': 'Szerviz garancia'
  };
  return typeNames[type] || type;
};

/**
 * Garancia státusz nevének lekérése magyar nyelven
 */
export const getWarrantyStatusName = (status: string): string => {
  const statusNames: Record<string, string> = {
    'active': 'Aktív',
    'expired': 'Lejárt',
    'claimed': 'Garanciális eset',
    'processing': 'Feldolgozás alatt',
    'resolved': 'Megoldva',
    'rejected': 'Elutasítva'
  };
  return statusNames[status] || status;
};

/**
 * Garancia dokumentum sablon kulcsok - csak a szükséges mezők
 */
export const warrantyKeys = {
  'Termék gyártmánya, típusa': '',
  'Gyártási szám': '',
  'Eladó neve': '',
  'Vásárló neve': '',
  'Alap garancia ideje': '',
  'Extra garancia ideje': '',
  'Dátum': ''
}; 